var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "pb-6" },
            [
              _vm._v(" Listados de Puntos Colombia "),
              _c("v-spacer"),
              _c("v-text-field", {
                staticStyle: { "max-width": "400px" },
                attrs: {
                  "append-icon": "mdi-magnify",
                  label: "Buscar",
                  "single-line": "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
              _c("v-spacer"),
            ],
            1
          ),
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.configs,
              search: _vm.search,
              "custom-filter": _vm.customFilter,
            },
            scopedSlots: _vm._u([
              {
                key: "item.NombreCompania",
                fn: function ({ item }) {
                  return [
                    _vm._v(
                      " [" +
                        _vm._s(item.IdCompania) +
                        "] " +
                        _vm._s(item.NombreCompania) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "item.Channel",
                fn: function ({ item }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getChannelDescription(item.Channel)) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "item.terminales",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "", color: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.openTerminal(item)
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v("mdi-laptop")])],
                      1
                    ),
                  ]
                },
              },
              {
                key: "item.acciones",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-menu",
                      {
                        attrs: { "offset-y": "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          attrs: { icon: "", color: "primary" },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c("v-icon", [
                                        _vm._v("mdi-dots-vertical"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openLogs(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-icon",
                                  [
                                    _c("v-icon", [
                                      _vm._v("mdi-file-code-outline"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c("v-list-item-title", [
                                  _vm._v(" Descargar Logs "),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openReport(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-icon",
                                  [
                                    _c("v-icon", [
                                      _vm._v("mdi-file-excel-outline"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c("v-list-item-title", [
                                  _vm._v(" Descargar Reporte "),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "item.editar",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "", color: "warning" },
                        on: {
                          click: function ($event) {
                            return _vm.editar(item)
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v("mdi-pencil")])],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("download-audit-dialog", {
        attrs: { company: _vm.selectedCompany, type: _vm.downloadType },
        on: { download: _vm.downloadAudit },
        model: {
          value: _vm.showDownloadDialog,
          callback: function ($$v) {
            _vm.showDownloadDialog = $$v
          },
          expression: "showDownloadDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }